//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import UserManagementTable from "@/pages/UserManagement/components/UserManagementTable.vue";
import UserManagementForm from "@/pages/UserManagement/components/UserManagementForm.vue";
import { Feedback } from "@/utils/notify-toaster.js";

//Status corrente está a vir se o utilizador esta atualmente com sessão iniciada
const EMPTY_USER = {
  id: null,
  name: null,
  email: null,
  type: null,
  department: null,
  department_id: null,
  role: null,
  role_id: null,
  status: null,
};

export default {
  name: "UserManagement",
  components: {
    UserManagementTable,
    UserManagementForm,
  },
  mounted: function () {
    this.fetchUsers();
  },
  data: () => ({
    data: null,
    recordsTotal: 0,
    isLoading: false,
    tableData: [],
    rightSideClicked: false,
    separator: "horizontal",
    pagination: {
      rowsPerPage: 30, // current rows per page being displayed
    },
    newUser: {},
    drawerMode: "",
  }),
  methods: {
    createNewUser: function () {
      this.rightSideClicked = true;
      this.drawerMode = "create";
      this.data = EMPTY_USER;
    },
    renderRightSide: function (event) {
      this.drawerMode = "edit";
      this.rightSideClicked = true;
      this.data = event;
    },
    closeForm: function () {
      this.rightSideClicked = false;
      this.newPhantomClicked = false;
    },
    updateUser(event) {
      this.newUser = event;
    },
    async fetchUsers() {
      this.isLoading = true;
      this.rightSideClicked = false;
      await BackendServices.getUsersList().then((response) => {
        this.recordsTotal = response.headers["x-total-count"];
        this.tableData = response.data;
        this.isLoading = false;
      });
    },

    save() {
      if (this.drawerMode === "create") {
        this.newUser.created_by = this.$store.getters.userId;
        this.createUser();
      } else if (this.drawerMode === "edit") {
        this.editUser();
      }
    },
    async createUser() {
      await BackendServices.createUser(this.newUser);
      this.fetchUsers();

      Feedback.success("Utilizador criado com sucesso");
      Feedback.warning("Enviado email de confirmação para o utilizador.");
    },
    async editUser() {
      await BackendServices.manageUser(this.newUser);
      this.fetchUsers();
      Feedback.success("Utilizador atualizado com sucesso");
    },
    async blockUser() {
      try {
        let response = await BackendServices.blockUser(this.newUser);
        this.fetchUsers();
        Feedback.success(response.data.message);
      } catch (err) {
        let error = err;
        if (error.response.status == 403) {
          Feedback.error(error.response.data.message);
        } else {
          Feedback.error("Ocorreu um erro ao bloquear o utilizador");
        }
      }
    },
    async deleteUser() {
      try {
        await BackendServices.deleteUser(this.newUser);
        this.fetchUsers();
        Feedback.success("Utilizador removido com sucesso");
      } catch (err) {
        let error = err;
        if (error.response.status == 403) {
          Feedback.error(error.response.data.message);
        } else {
          Feedback.error("Ocorreu um erro ao eliminar o utilizador");
        }
      }
    },
  },
};
